import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CommonResponse } from '../../models';
import { environment } from '../../../../environments/environment';
import { ProfileUserUniversitySchoolUniversity } from '../../models/profile/profile';
import { LogBook } from '../../models/registration/log-book';
import { map } from 'rxjs/operators';
import { DidacticProgram } from '../../models/didactic-program/didactic-program';
import { Career } from '../../models/career/career';

@Injectable({
	providedIn: 'root',
})
export class OperationalTutorService {
	constructor(private _http: HttpClient) {}

	getTraineeFilteredByOperationalTutors(): Observable<CommonResponse<Array<ProfileUserUniversitySchoolUniversity>>> {
		return this._http.get<CommonResponse<Array<ProfileUserUniversitySchoolUniversity>>>(
			`/profiles_users_universities_schools_universities/trainees/filtered_by/operational_tutor`
		);
	}

	getLastTenRegistration(): Observable<CommonResponse<Array<LogBook>>> {
		return this._http.get<CommonResponse<Array<LogBook>>>(`${environment.apiUrl}/operational_tutor/log_books/last_ten`).pipe(
			map(response => {
				if (response.data) {
					response.data.forEach(logBook => {
						const totQuantity = logBook.log_book_details.reduce((acc, item) => acc + item.quantity, 0);
						const totMinutes = logBook.log_book_details.reduce((acc, item) => acc + item.minutes, 0);
						logBook.tot_quantity = totQuantity;
						logBook.tot_minutes = totMinutes;
					});
				}
				return response;
			})
		);
	}

	getResgistrationsList(): Observable<CommonResponse<Array<LogBook>>> {
		return this._http.get<CommonResponse<Array<LogBook>>>(`${environment.apiUrl}/operational_tutor/log_books`).pipe(
			map(response => {
				if (response.data) {
					response.data.forEach(logBook => {
						const totQuantity = logBook.log_book_details.reduce((acc, item) => acc + item.quantity, 0);
						const totMinutes = logBook.log_book_details.reduce((acc, item) => acc + item.minutes, 0);
						logBook.tot_quantity = totQuantity;
						logBook.tot_minutes = totMinutes;
					});
				}
				return response;
			})
		);
	}

	getRegistrationFilteredByYear(year: string): Observable<CommonResponse<Array<LogBook>>> {
		return this._http
			.get<CommonResponse<Array<LogBook>>>(`${environment.apiUrl}/operational_tutor/log_books/filtered_by/year/${year}`)
			.pipe(
				map(response => {
					if (response.data) {
						response.data.forEach(logBook => {
							const totQuantity = logBook.log_book_details.reduce((acc, item) => acc + item.quantity, 0);
							const totMinutes = logBook.log_book_details.reduce((acc, item) => acc + item.minutes, 0);
							logBook.tot_quantity = totQuantity;
							logBook.tot_minutes = totMinutes;
						});
					}
					return response;
				})
			);
	}

	confirmRegistrations(data: { status: string; log_book_detail_ids: Array<string> }): Observable<CommonResponse<boolean>> {
		return this._http.patch<CommonResponse<boolean>>(`${environment.apiUrl}/operational_tutor/log_book_details`, data);
	}

	getSkillTotalizersForLogBookDetails(
		log_book_detail_ids: Array<string>
	): Observable<CommonResponse<{ totalizers: Array<any>; career_id: string }>> {
		return this._http.post<CommonResponse<{ totalizers: Array<any>; career_id: string }>>(
			`${environment.apiSchoolUrl}/career/log_book_details/totalizers`,
			{
				log_book_detail_ids,
			}
		);
	}

	getSkillTotalizersByYear(year: number): Observable<CommonResponse<{ totalizers: Array<any>; career_id: string }>> {
		return this._http.get<CommonResponse<{ totalizers: Array<any>; career_id: string }>>(
			`${environment.apiSchoolUrl}/career/log_book_details/skill_totalizers/year/${year}`
		);
	}

	assignSkillTotalizersByYear(year: number, data: { totalizer_ids: Array<string> }): Observable<CommonResponse<boolean>> {
		return this._http.post<CommonResponse<boolean>>(
			`${environment.apiSchoolUrl}/career/log_book_details/skill_totalizers/year/${year}/assign`,
			data
		);
	}

	getDashboardStats(): Observable<
		CommonResponse<{
			trainee_stats: Array<{ operational_unit_name: string; trainee_count: number }>;
			log_book_stats: Array<{ status: string; status_count: number }>;
		}>
	> {
		return this._http.get<
			CommonResponse<{
				trainee_stats: Array<{ operational_unit_name: string; trainee_count: number }>;
				log_book_stats: Array<{ status: string; status_count: number }>;
			}>
		>(`/operational_units_profiles_users/dashboard_stats/filtered_by/operational_tutor`);
	}

	getRotationsFilteredByAuthOperationalTutor(): Observable<CommonResponse<Array<any>>> {
		return this._http.get<CommonResponse<Array<any>>>(
			`/careers_operational_units_schools_universities/filtered_by/auth_operational_unit_profile_user`
		);
	}

	getRotationsForCareerFilteredByAuthOperationalTutor(careerId: string): Observable<CommonResponse<Array<any>>> {
		return this._http.get<CommonResponse<Array<any>>>(
			`/careers_operational_units_schools_universities/filtered_by/auth_operational_unit_profile_user_and_career/${careerId}`
		);
	}
}
